import React from 'react';
import { CarFront, MessageCircle, PackageCheck } from 'lucide-react';

const fmt = (iso) => new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });

// Ready / delivered actions for a saved job card: send the ready card, hand the car over.
export const JobCardHandover = ({ card, onSend, onDeliver, busy }) => {
  const ready = ['ready', 'invoiced'].includes(card.status);
  const phone = !!card.customer_snapshot?.phone;
  return (
    <div className={`flex flex-wrap items-center gap-2 rounded-xl border p-4 ${ready ? 'border-emerald-200 bg-emerald-50' : 'border-slate-200 bg-white'}`} data-testid="jc-handover">
      <span className="mr-auto flex items-center gap-2 text-sm text-slate-700">
        <CarFront size={16} className={ready ? 'text-emerald-700' : 'text-slate-400'} />
        {card.delivered_at ? <span data-testid="jc-delivered-at">Delivered {fmt(card.delivered_at)}. A thank-you with your review link is due the next day on the Feedback page.</span>
          : ready ? 'The car is ready. Let the customer know, then mark it delivered when they collect it.'
            : 'Send the customer a branded “ready for pickup” card whenever the work is done.'}
      </span>
      <button type="button" onClick={onSend} disabled={!phone} title={phone ? '' : 'Add a phone number to the customer first'} className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-500 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-emerald-600 disabled:opacity-50" data-testid="jc-send-ready-btn">
        <MessageCircle size={14} /> Send ready card
      </button>
      {ready && !card.delivered_at && (
        <button type="button" onClick={onDeliver} disabled={busy} className="inline-flex items-center gap-1.5 rounded-lg border border-emerald-300 bg-white px-3 py-2 text-sm font-semibold text-emerald-800 transition-colors hover:bg-emerald-100 disabled:opacity-50" data-testid="jc-mark-delivered-btn">
          <PackageCheck size={14} /> Mark delivered
        </button>
      )}
    </div>
  );
};
